import { render } from "./UsersAndRoles.vue?vue&type=template&id=6e36179e&scoped=true"
import script from "./UsersAndRoles.vue?vue&type=script&lang=js"
export * from "./UsersAndRoles.vue?vue&type=script&lang=js"

import "./UsersAndRoles.vue?vue&type=style&index=0&id=6e36179e&lang=css"
import "./UsersAndRoles.vue?vue&type=style&index=1&id=6e36179e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e36179e"]])

export default __exports__